import React, { useState } from "react";

function Faq({ data }) {
  const [faqData, setFaqData] = useState(data);

  const toggleAnswer = (index) => {
    setFaqData((prevFaqData) =>
      prevFaqData.map((item, idx) => ({
        ...item,
        show: idx === index ? !item.show : false,
      }))
    );
  };

  return (
    <section className="layout-section">
      <div className="layout-container layout-container--narrow">
        <h1 id="heading-large">FAQs</h1>
        <p id="dark">Find answers to all your questions</p>
        <div className="my-6">
          {faqData.map((faq, index) => (
            <div key={index} className="my-4 border-b border-slate-200 pb-4">
              <div className="flex items-center justify-between gap-4">
                <button
                  type="button"
                  onClick={() => toggleAnswer(index)}
                  className="font-bold cursor-pointer text-left flex-1"
                >
                  {faq.question}
                </button>
                <button
                  type="button"
                  className="cursor-pointer flex-shrink-0"
                  onClick={() => toggleAnswer(index)}
                  aria-label={faq.show ? "Collapse" : "Expand"}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d={faq.show ? "M19 9l-7 7-7-7" : "M5 15l7-7 7 7"}
                    />
                  </svg>
                </button>
              </div>
              {faq.show && (
                <div className="mt-3 text-gray-600 leading-relaxed">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Faq;
